import { Switch } from "antd";
import Text from "antd/es/typography/Text";
import { useState } from "react";
import { isAdmin, isViewAsAdmin, setViewAsAdmin } from "../../util/viewAsAdmin";

export const ViewAsAdminToggle: React.FC = () => {
  const [viewAsAdmin, setViewAsAdminState] = useState<boolean>(isViewAsAdmin);

  if (!isAdmin()) {
    return null;
  }

  const toggleAdminView = (checked: boolean) => {
    setViewAsAdmin(checked);
    setViewAsAdminState(checked);
  };

  return (
    <div className="flex items-center gap-2">
      <Switch
        className="ml-5"
        checked={viewAsAdmin}
        onChange={toggleAdminView}
      />
      <Text>View as Admin</Text>
    </div>
  );
};
